function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.734 12.898c3.081-3.008 3.011-7.82-.156-10.746C11.411-.774 6.347-.708 3.266 2.3c-3.021 2.95-3.021 7.648 0 10.598l.021.025.026.025.063.06 4.995 4.745c.348.33.91.33 1.257 0l4.995-4.745.064-.06.026-.025.021-.025z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "9",
  cy: "7.8",
  r: "4.25",
  stroke: "#F1F1F1",
  strokeWidth: "1.5"
})));